import { useState, type ReactElement } from "react";
import { Tooltip } from "@its-engineering-and-development/ui-foundation/components";

export interface BlockedActionTooltipProps {
    /** Explanation shown on hover/focus of the blocked trigger. */
    title: string;
    /** Render the inert trigger; call `reveal` from its press handler to re-open the tooltip. */
    children: (reveal: () => void) => ReactElement;
}

/** Tooltip for an inert trigger; pressing the trigger re-opens it, since a press otherwise closes it for good. */
export function BlockedActionTooltip({ title, children }: BlockedActionTooltipProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Tooltip title={title} isOpen={isOpen} onOpenChange={setIsOpen}>
            {children(() => setIsOpen(true))}
        </Tooltip>
    );
}
